import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

const ONE_MINUTE = 60000;
const ONE_HOUR = ONE_MINUTE * 60;

const appIdDev = '1:668375113353:web:9dd1eaf4564985d0183058';
const appIdAcc = '1:668375113353:web:b323fdc150aefc30183058';
const appIdProd = '1:668375113353:web:d5a4fef6dbeb1544183058';

const getAppId = (environment: string) => {
  if (environment === 'acc') return appIdAcc;
  if (environment === 'dev') return appIdDev;
  if (environment === 'prod') return appIdProd;
  return appIdDev;
};

export function getRemoteConfigByEnvironment(environment: string) {
  const firebaseConfig = {
    apiKey: 'AIzaSyDUs2Q0ihB-VhAvgnEuLQFD4sCrB5BMcJ0',
    authDomain: 'provider-extranet---bxl.firebaseapp.com',
    projectId: 'provider-extranet---bxl',
    storageBucket: 'provider-extranet---bxl.firebasestorage.app',
    messagingSenderId: '668375113353',
    appId: getAppId(environment),
  };

  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);

  remoteConfig.settings = {
    minimumFetchIntervalMillis: ONE_HOUR,
    fetchTimeoutMillis: ONE_MINUTE,
  };

  return remoteConfig;
}
